import gql from 'graphql-tag';

import conversationFragment from '../fragments/conversationFragment';

export default gql`
  query conversation($id: DokkioID!) {
    conversation(id: $id) {
      ...conversationFragment
    }
  }
  ${conversationFragment}
`;
